import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

const useSurveyStyles = createSurveyStyles((theme: SurveyThemeType) => {
  return {
    exitLink: {
      padding: 0,
      height: 'auto',
      fontFamily: 'inherit',
      fontSize: theme?.exitLink?.fontSize,
      fontWeight: theme?.exitLink?.fontWeight,
      color: theme?.titleColor,
      backgroundColor: theme?.exitLink?.backgroundColor,
      transition: theme.isAccessible ? '0.1s all linear' : 'none',
      textDecoration: 'none',
      '&:focus, &:hover': {
        textDecoration: 'none',
        outlineOffset: theme.isAccessible ? 4 : 'none',
        outline: theme.isAccessible ? ['1px solid', theme.questionColor] : 'none',
      },
    },
  };
});

export default useSurveyStyles;
